// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'
import { sagaScopeSchema } from './sagaMemory'

export const sagaTaskSummarySchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  agentId: z.string().max(200),
  totalCompleted: z.number().int().min(0).default(0),
  totalFailed: z.number().int().min(0).default(0),
  totalInProgress: z.number().int().min(0).default(0),
  firstTaskAt: z.string().max(200).datetime().optional(),
  lastTaskAt: z.string().max(200).datetime().optional(),
  bySkill: z.record(z.string(), z.number()).optional(),

  scope: sagaScopeSchema,

  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
})

export type SagaTaskSummaryInput = z.infer<typeof sagaTaskSummarySchema>
